import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { MdSearch } from "react-icons/md";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { useSnackbar } from "notistack";
import ConfirmationModal from "../../../../common/confirm/ConfirmationModal";
import { fetchFilesByLeadId } from "../../../../../store/slices/fileSlice";
import { useDispatch, useSelector } from "react-redux";
import { deleteLead } from "./../../../../../store/slices/leadsSlice";
// import { setFilteredReports } from "../../../../../store/slices/filteredDataSlice";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import FileUploadFollowupTable from "./FileUploadFollowupTable";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {
  ChevronUp,
  ChevronDown,
  SquarePen,
  Trash2,
  EllipsisVertical,
} from "lucide-react";
import { getAllFiles } from "../../../../../store/slices/FileDataSlice";
import { useCurrencySymbol } from "../../../../../utils/currencyUtils";
import DateConversion from "../../../../../utils/DateConversion";
import CommaConvert from "../../../../../utils/CommaConvert";
import DownloadReport from "../../../../../pages/lead/DownloadReport";
import { setDownloadReportTitle } from "../../../../../store/slices/pageSlice";
import { hasViewOrFullAccess, getFeatureAccessLevel, getExactFeatureAccessLevel } from "../../../../../utils/featureAccessUtils";
import {
  readFollowupTableExpanded,
  writeFollowupTableExpanded,
} from "../../../../../utils/followupTablePrefs";

const FollowupTable = ({
  wrapperClasses,
  currentEmployee,
  hasNoFeatureConfig,
  userLevel,
  hideActionColumn = false,
}) => {
  const dispatch = useDispatch();

  const downloadAccessLevel = !hasNoFeatureConfig && currentEmployee
    ? (
      getExactFeatureAccessLevel(currentEmployee, "FOLLOW-UP-TABLE DOWNLOAD")
      ?? getExactFeatureAccessLevel(currentEmployee, "FOLLOW-UP-TABLE")
    )
    : null;
  const isDownloadViewOnly = downloadAccessLevel && String(downloadAccessLevel).trim().toUpperCase() === "VIEW ONLY";

  const sendDownlodTile = () => {
    if (isDownloadViewOnly) return;
    dispatch(setDownloadReportTitle("Follow-up-report"));
  };

  const [, setFilteredLeadReports] = useState([]);
  const [LeadReports, setLeadReports] = useState([]);
  const [tableLeadReports, setTableLeadReports] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [attchmentLead, setattchmentLead] = useState("");
  const filteredDataState = useSelector((state) => state.filteredData);
  const groupsFromSlice = useSelector((state) => state.group?.group || []);
  console.log("FollowupTable - Entire filteredData state:", filteredDataState);

  const { filteredReports } = useSelector((state) => state.filteredData);
  const groupNameById = useMemo(() => {
    const normalize = (value) => String(value ?? "").trim();
    const map = new Map();
    const groups = Array.isArray(groupsFromSlice) ? groupsFromSlice : [];
    groups.forEach((groupItem) => {
      const groupId = normalize(groupItem?._id ?? groupItem?.id);
      if (!groupId) return;
      const groupName = normalize(
        groupItem?.name ??
          groupItem?.newGroupName ??
          groupItem?.groupName ??
          groupItem?.GroupName ??
          groupId
      );
      map.set(groupId, groupName || groupId);
    });
    return map;
  }, [groupsFromSlice]);
  const getLeadGroupName = useCallback(
    (lead) => {
      const normalize = (value) => String(value ?? "").trim();
      const groupIdFromObject = normalize(lead?.groupid?._id ?? lead?.groupid?.id);
      if (groupIdFromObject && groupNameById.has(groupIdFromObject)) {
        return groupNameById.get(groupIdFromObject);
      }
      const groupIdFromString = typeof lead?.groupid === "string" ? normalize(lead.groupid) : "";
      if (groupIdFromString && groupNameById.has(groupIdFromString)) {
        return groupNameById.get(groupIdFromString);
      }
      return (
        lead?.AssignedGroupName ||
        lead?.AssignedGroup ||
        lead?.groupid?.name ||
        groupIdFromString ||
        ""
      );
    },
    [groupNameById]
  );

  console.log("gsdgsdg", filteredReports);
  const currency = useCurrencySymbol();
  const { formatDateByCountry } = DateConversion();
  const USAComma = CommaConvert();

  // const { allFiles } = useSelector((state) => state?.fileData);
  const dropdownRef = useRef(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [filteredLeadReportsLead, setFilteredLeadReportsLead] = useState([]);

  const currentAuthLevel = String(currentEmployee?.EmpAuthLevel || userLevel || "")
      .trim()
      .toUpperCase();
  const isFinanceDeptUser = currentAuthLevel === "L2";
  const isDirector = currentAuthLevel === "L1";
  const showActionColumn = !(hideActionColumn || isFinanceDeptUser || isDirector);

  const followUpAccessLevel = getFeatureAccessLevel(currentEmployee, "FOLLOW-UP-TABLE");
  const isViewOnly = !!currentEmployee && !hasNoFeatureConfig &&
    followUpAccessLevel &&
    String(followUpAccessLevel).trim().toUpperCase() === "VIEW ONLY";


  useEffect(() => {
    if (Array.isArray(filteredReports)) {
        setFilteredLeadReportsLead(filteredReports);
    }
}, [filteredReports]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // If dropdown is open and click is outside the dropdown AND not on the dropdown icon
      if (
        openDropdownId &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        // Also check if the click was on the ellipsis icon itself
        const clickedElement = event.target;
        const isEllipsisIcon = clickedElement.closest(".dropdown-toggle-icon");

        if (!isEllipsisIcon) {
          setOpenDropdownId(null);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openDropdownId]);

  useEffect(() => {
    dispatch(getAllFiles());
    // dispatch(setFilteredReports());
  }, [dispatch]);

  const parseDate = useCallback((dateStr) => {
    if (!dateStr) return null;
    let parsedDate = new Date(dateStr);
    if (!isNaN(parsedDate.getTime())) {
      return parsedDate;
    }
    const parts = dateStr.toString().split("-");
    if (parts.length === 3) {
      const [month, day, year] = parts.map(Number);
      // Validate date components
      if (month >= 1 && month <= 12 && day >= 1 && day <= 31 && year > 2000) {
        const newDate = new Date(year, month - 1, day);
        if (!isNaN(newDate.getTime())) {
          return newDate;
        }
      }
    }
    return null;
  }, []);

  // const getColorPriority = useCallback((followUpDate) => {
  //     if (!followUpDate) return 3;

  //     const today = parseDate(new Date());
  //     const followDate = parseDate(followUpDate);

  //     if (!today || !followDate) return 3;

  //     today.setHours(0, 0, 0, 0);
  //     followDate.setHours(0, 0, 0, 0);

  //     if (followDate <= today) return 1;

  //     const twoMonthsFromToday = new Date(today);
  //     twoMonthsFromToday.setMonth(twoMonthsFromToday.getMonth() + 2);

  //     if (followDate <= twoMonthsFromToday) return 2;

  //     return 3;
  // }, [parseDate]);

  const getColorPriority = useCallback(
    (followUpDate) => {
      if (!followUpDate) return 4;

      const today = parseDate(new Date());
      const followDate = parseDate(followUpDate);

      if (!today || !followDate) return 4;

      today.setHours(0, 0, 0, 0);
      followDate.setHours(0, 0, 0, 0);

      // 1️⃣ Past date
      if (followDate < today) return 1;

      // Date ranges from today
      const twoMonths = new Date(today);
      twoMonths.setMonth(twoMonths.getMonth() + 2);

      const fourMonths = new Date(today);
      fourMonths.setMonth(fourMonths.getMonth() + 4);

      const sixMonths = new Date(today);
      sixMonths.setMonth(sixMonths.getMonth() + 6);

      // 2️⃣ Future within 0–2 months
      if (followDate <= twoMonths) return 2;

      // 3️⃣ Future within 2–4 months
      if (followDate <= fourMonths) return 3;

      // 4️⃣ Future within 4–6 months
      if (followDate <= sixMonths) return 4;

      return 5;
    },
    [parseDate]
  );

  useEffect(() => {
    // Early return if no filteredReports or it's empty
    if (!filteredLeadReportsLead || !filteredLeadReportsLead.length) {
      console.log("No filtered reports available");
      setLeadReports([]);
      setTableLeadReports([]);
      return;
    }

    console.log("Processing filteredReports:", filteredLeadReportsLead);

    const pageItems = filteredLeadReportsLead.filter((LeadReport) => {
      const twoYearsAgo = new Date();
      twoYearsAgo.setFullYear(twoYearsAgo.getFullYear() - 2);

      const leadDate = parseDate(LeadReport.LeadDate);
      const status = LeadReport.Status?.toLowerCase() || "";

      return (
        leadDate >= twoYearsAgo &&
        (status === "pending" || status === "won recurring")
      );
    });

    console.log("pageItems after filtering:", pageItems);

    // If no valid pageItems, reset and exit
    if (!pageItems || pageItems.length === 0) {
      setLeadReports([]);
      setTableLeadReports([]);
      return;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const sixMonthsFromToday = new Date(today);
    sixMonthsFromToday.setMonth(today.getMonth() + 6);

    const filteredItems = pageItems.filter((item) => {
      if (!item?.FollowupDate) return false;

      const followupDate = new Date(item.FollowupDate);
      followupDate.setHours(0, 0, 0, 0);

      return followupDate <= sixMonthsFromToday;
    });

    console.log("filteredItems after date filtering:", filteredItems);

    // If no items after date filtering, reset and exit
    if (!filteredItems || filteredItems.length === 0) {
      setLeadReports([]);
      setTableLeadReports([]);
      return;
    }

    const sortedByPriority = filteredItems
      .filter((item) => item?.FollowupDate) // EXCLUDE missing FollowupDate
      .sort((a, b) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const da = new Date(a.FollowupDate);
        const db = new Date(b.FollowupDate);

        da.setHours(0, 0, 0, 0);
        db.setHours(0, 0, 0, 0);

        const isPastA = da < today;
        const isPastB = db < today;

        // 1️⃣ Past dates always on top
        if (isPastA && !isPastB) return -1;
        if (!isPastA && isPastB) return 1;

        // 2️⃣ Older date first
        return da - db;
      });

    console.log("sortedByPriority:", sortedByPriority);

    setLeadReports(sortedByPriority);
    setTableLeadReports(sortedByPriority);
  }, [filteredLeadReportsLead, parseDate]); // Removed getColorPriority dependency if not used

  //   useEffect(() => {
  //     const pageItems = filteredReports?.filter((LeadReport) => {
  //       const twoYearsAgo = new Date();
  //       twoYearsAgo.setFullYear(twoYearsAgo.getFullYear() - 2);

  //       const leadDate = parseDate(LeadReport.LeadDate);
  //       const status = LeadReport.Status?.toLowerCase() || "";

  //       return (
  //         leadDate >= twoYearsAgo &&
  //         (status === "pending" || status === "won recurring")
  //       );
  //     });
  //     console.log("pageItems pageItems", pageItems);

  //     const today = new Date();
  //     today.setHours(0, 0, 0, 0);

  //     const sixMonthsFromToday = new Date(today);
  //     sixMonthsFromToday.setMonth(today.getMonth() + 6);

  //     const filteredItems = (Array.isArray(pageItems) ? pageItems : []).filter(
  //       (item) => {
  //         if (!item?.FollowupDate) return false;

  //         const followupDate = new Date(item.FollowupDate);
  //         followupDate.setHours(0, 0, 0, 0);

  //         // ✅ all past + future within 6 months
  //         return followupDate <= sixMonthsFromToday;
  //       }
  //     );

  //     console.log("pageItems filteredItems", filteredItems);

  //     if (Array.isArray(filteredItems)) {
  //       if (!filteredReports?.length) return;

  //       const sortedByPriority = filteredItems
  //         .filter((item) => item?.FollowupDate) // ✅ EXCLUDE missing FollowupDate
  //         .sort((a, b) => {
  //           const today = new Date();
  //           today.setHours(0, 0, 0, 0);

  //           const da = new Date(a.FollowupDate);
  //           const db = new Date(b.FollowupDate);

  //           da.setHours(0, 0, 0, 0);
  //           db.setHours(0, 0, 0, 0);

  //           const isPastA = da < today;
  //           const isPastB = db < today;

  //           // 1️⃣ Past dates always on top
  //           if (isPastA && !isPastB) return -1;
  //           if (!isPastA && isPastB) return 1;

  //           // 2️⃣ Older date first
  //           return da - db;
  //         });
  //       console.log("pageItems sortedByPriority", sortedByPriority);

  //       setLeadReports(sortedByPriority);
  //       setTableLeadReports(sortedByPriority);
  //     }
  //   }, [filteredReports, getColorPriority, parseDate]);

  const getRowClass = (followUpDate) => {
    const priority = getColorPriority(followUpDate);

    switch (priority) {
      case 1:
        return "bg-red-500/15 border-red-500";
      case 2:
        return "bg-red-400/15 border-red-400";
      case 3:
        return "bg-orange-400/15 border-orange-400";
      case 4:
        return "bg-green-400/15 border-green-400";
      default:
        return "";
    }
  };

  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;
  const currentItems = tableLeadReports.slice(startIdx, endIdx);
  const totalItems = tableLeadReports.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  console.log("gsdgsdg currentItems", currentItems);
  console.log("gsdgsdg tableLeadReports", tableLeadReports);

  const [showTable, setShowTable] = useState(() =>
    isFinanceDeptUser ? readFollowupTableExpanded() : true
  );

  useEffect(() => {
    if (!isFinanceDeptUser) {
      setShowTable(true);
      return;
    }
    setShowTable(readFollowupTableExpanded());
  }, [isFinanceDeptUser]);

  const handleToggleTable = () => {
    setShowTable((prev) => {
      const next = !prev;
      if (isFinanceDeptUser) {
        writeFollowupTableExpanded(next);
      }
      return next;
    });
  };

  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchInputChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    filterLeadReports(query);
    setCurrentPage(1);
  };

  const filterLeadReports = (query) => {
    const lowerQuery = query.replace(/,/g, "").toLowerCase();
    const lowerCaseQuery = lowerQuery.toLowerCase().trim();

    const filtered = LeadReports.filter((LeadReport) =>
      Object.entries(LeadReport).some(([key, value]) => {
        if (
          key === "comments" ||
          key === "Reference" ||
          key === "ClientContactName" ||
          key === "TypeService" ||
          key === "Probability" ||
          key === "ClientPhone" ||
          key === "ClientEmail" ||
          key === "Source" ||
          key === "LeadOwner" ||
          key === "AssignedPeople" ||
          key === "AssignedPeopleEmail" ||
          key === "LeadOwnerEmail" ||
          key === "quotedExpense" ||
          key === "_id" ||
          key === "id" ||
          key === "__v" ||
          key === "createdAt" ||
          key === "updatedAt"
        )
          return false;

        if (value !== null && value !== undefined) {
          if (key === "AssignedGroup" || key === "groupid") {
            return getLeadGroupName(LeadReport).toLowerCase().includes(lowerCaseQuery);
          }
          let formattedValue = value.toString().trim().toLowerCase();

          // If value is a Date object
          if (value instanceof Date) {
            formattedValue = formatDateByCountry(value).trim().toLowerCase();
          }
          // If value is a string that might be a date (ISO format)
          else if (typeof value === "string") {
            const dateValue = new Date(value);
            if (!isNaN(dateValue)) {
              formattedValue = formatDateByCountry(dateValue)
                .trim()
                .toLowerCase();
            }
          }

          return formattedValue.includes(lowerCaseQuery);
        }
        return false;
      })
    );
    setTableLeadReports(filtered);
  };

  const [, setUploadedFiles] = useState([]);
  const [, setFetchedFiles] = useState([]);
  const [leadId] = useState("");

  const fetchFiles = useCallback(
    async (leadId) => {
      if (!leadId) return;
      setUploadedFiles([]);
      setFetchedFiles([]);
      try {
        const response = await dispatch(fetchFilesByLeadId(leadId)).unwrap();
        setUploadedFiles(response);
        setFetchedFiles(response);
      } catch (error) {
        console.error("Error fetching files:", error);
      }
    },
    [dispatch, setUploadedFiles, setFetchedFiles]
  );

  useEffect(() => {
    if (!leadId) {
      setUploadedFiles([]);
      setFetchedFiles([]);
      return;
    }
    fetchFiles(leadId);
  }, [leadId, fetchFiles, setUploadedFiles]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [LeadToDelete, setLeadToDelete] = useState(null);
  console.log("LeadToDelete", LeadToDelete);

  const openDeleteModal = (id) => {
    if (isViewOnly) return;
    setLeadToDelete(id);
    setIsModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsModalOpen(false);
    setLeadToDelete(null);
  };

  const confirmDelete = async () => {
    if (LeadToDelete) {
      await deleteLeadReport(LeadToDelete);
      setLeadToDelete(null);
    }
    closeDeleteModal();
  };

  const deleteLeadReport = async (id) => {
    try {
      const resultAction = await dispatch(deleteLead(id));

      if (deleteLead.fulfilled.match(resultAction)) {
        enqueueSnackbar("Lead report deleted successfully!", {
          variant: "success",
        });
        setFilteredLeadReports((prevReports) =>
          prevReports.filter((report) => report.id !== id)
        );
        setLeadToDelete(null);
      } else {
        enqueueSnackbar("Failed to delete Lead report!", { variant: "error" });
      }
    } catch (error) {
      console.error("Error:", error);
      enqueueSnackbar("Connection Error!", { variant: "error" });
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      // If parsing fails, try parsing as MM-DD-YYYY format
      const parts = dateString.toString().split("-");
      if (parts.length === 3) {
        const [month, day, year] = parts;
        const newDate = new Date(year, month - 1, day);
        if (!isNaN(newDate.getTime())) {
          const formattedMonth = String(newDate.getMonth() + 1).padStart(
            2,
            "0"
          );
          const formattedDay = String(newDate.getDate()).padStart(2, "0");
          const formattedYear = newDate.getFullYear();
          return `${formattedMonth}-${formattedDay}-${formattedYear}`;
        }
      }
      return ""; // Return empty string for invalid dates
    }

    // Format the valid date as MM-DD-YYYY
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  };

  // Modified sorting functions - sort the entire dataset before filtering
  const sortAlphabetically = (targetToSort, order) => {
    if (!Array.isArray(LeadReports) || LeadReports.length === 0) {
      console.warn("⚠️ filteredReports is not ready yet");
      return;
    }

    const key = `${targetToSort}-${order}`;
    let sorted = [];

    const sourceArray = [...LeadReports];

    switch (key) {
      case "business-az":
        sorted = sourceArray.sort((a, b) =>
          getLeadGroupName(a).localeCompare(getLeadGroupName(b))
        );
        break;

      case "business-za":
        sorted = sourceArray.sort((a, b) =>
          getLeadGroupName(b).localeCompare(getLeadGroupName(a))
        );
        break;

      case "client-az":
        sorted = sourceArray.sort((a, b) =>
          a.ClientName.localeCompare(b.ClientName)
        );
        break;

      case "client-za":
        sorted = sourceArray.sort((a, b) =>
          b.ClientName.localeCompare(a.ClientName)
        );
        break;

      case "project-az":
        sorted = sourceArray.sort((a, b) =>
          a.ProjectName.localeCompare(b.ProjectName)
        );
        break;

      case "project-za":
        sorted = sourceArray.sort((a, b) =>
          b.ProjectName.localeCompare(a.ProjectName)
        );
        break;

      case "leadtype-az":
        sorted = sourceArray.sort((a, b) =>
          a.LeadType.localeCompare(b.LeadType)
        );
        break;

      case "leadtype-za":
        sorted = sourceArray.sort((a, b) =>
          b.LeadType.localeCompare(a.LeadType)
        );
        break;

      case "leadstatus-az":
        sorted = sourceArray.sort((a, b) => a.Status.localeCompare(b.Status));
        break;

      case "leadstatus-za":
        sorted = sourceArray.sort((a, b) => b.Status.localeCompare(a.Status));
        break;

      case "leadate-az":
        sorted = sourceArray.sort((a, b) => {
          const dateA = a.LeadDate
            ? new Date(formatDate(a.LeadDate))
            : new Date(0);
          const dateB = b.LeadDate
            ? new Date(formatDate(b.LeadDate))
            : new Date(0);
          return dateA - dateB;
        });
        break;

      case "leadate-za":
        sorted = sourceArray.sort((a, b) => {
          const dateA = a.LeadDate
            ? new Date(formatDate(a.LeadDate))
            : new Date(0);
          const dateB = b.LeadDate
            ? new Date(formatDate(b.LeadDate))
            : new Date(0);
          return dateB - dateA;
        });
        break;

      case "followupdate-az":
        sorted = sourceArray.sort((a, b) => {
          const dateA = a.FollowupDate
            ? new Date(formatDate(a.FollowupDate))
            : new Date(0);
          const dateB = b.FollowupDate
            ? new Date(formatDate(b.FollowupDate))
            : new Date(0);
          return dateA - dateB;
        });
        break;

      case "followupdate-za":
        sorted = sourceArray.sort((a, b) => {
          const dateA = a.FollowupDate
            ? new Date(formatDate(a.FollowupDate))
            : new Date(0);
          const dateB = b.FollowupDate
            ? new Date(formatDate(b.FollowupDate))
            : new Date(0);
          return dateB - dateA;
        });
        break;
      default:
        return;
    }
    setLeadReports(sorted);
    setTableLeadReports(sorted);
  };

  const numericSort = (order) => {
    if (!Array.isArray(LeadReports) || LeadReports.length === 0) {
      return;
    }
    const sorted = [...LeadReports].sort((a, b) =>
      order === "az"
        ? Number(a.QuotedValue) - Number(b.QuotedValue)
        : Number(b.QuotedValue) - Number(a.QuotedValue)
    );
    setLeadReports(sorted);
    setTableLeadReports(sorted);
  };

  const isSameDay = (d1, d2) => {
    if (!d1 || !d2) return false;

    const a = parseDate(d1);
    const b = parseDate(d2);

    if (!a || !b) return false;

    a.setHours(0, 0, 0, 0);
    b.setHours(0, 0, 0, 0);

    return a.getTime() === b.getTime();
  };

  return (
    <div className="">
      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={closeDeleteModal}
        onConfirm={confirmDelete}
      />
      <div className="w-full  rounded-md">
        <div className="flex justify-between items-center p-2 bg-white rounded-t-md">
          {/* Left side */}
          <div className="flex w-1/2 justify-start items-start gap-2">
            <h1 className="text-xl  capitalize">Follow-up Table</h1>

            <div
              onClick={handleToggleTable}
              className="flex justify-center items-center  w-7 h-7 cursor-pointer bg-white"
            >
              {showTable ? (
                <ChevronDown className="w-5 h-5" />
              ) : (
                <ChevronUp className="w-5 h-5" />
              )}
            </div>
          </div>

          <div className="flex w-1/2 justify-end items-center gap-4">
            {showTable && (userLevel === "L0" || hasNoFeatureConfig || !currentEmployee || hasViewOrFullAccess(currentEmployee, "FOLLOW-UP-TABLE DOWNLOAD")) && (
              <span
                className={isDownloadViewOnly ? 'opacity-60 pointer-events-none cursor-not-allowed text-[#9ca3af]' : ''}
                onClick={() => {
                  sendDownlodTile();
                }}
              >
                <DownloadReport tableLeadReports={tableLeadReports} />
              </span>
            )}
            {showTable && (
              <div className=" flex items-center gap-2 p-1 bg-white rounded-md border border-gray-200 w-[420px] md:w-1/2 ">
                <MdSearch className="w-5 h-5 text-gray-500" />
                <input
                  type="text"
                  value={searchQuery}
                  onChange={handleSearchInputChange}
                  placeholder="Search"
                  className=" outline-none w-full"
                />
              </div>
            )}
          </div>
        </div>

        {showTable && (
          <div>
            <div className="min-h-[10rem] ">
              <div className="head flex w-full bg-[#e8e8e8] text-black text-xs font-semibold border-b border-gray-400">
                <div className="w-[5%] flex justify-center align-middle items-center  rounded-tl-md">
                  Sr. No
                </div>
                <div className="w-[9.3%] p-1 flex justify-between align-middle items-center ">
                  <div className="w-[65%]">Lead Date</div>
                  <div className="w-[35%] flex flex-col gap-y-1">
                    <div
                      className="cursor-pointer "
                      onClick={() => sortAlphabetically("leadate", "az")}
                    >
                      <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                    </div>

                    <div
                      className="cursor-pointer -mt-2"
                      onClick={() => sortAlphabetically("leadate", "za")}
                    >
                      <ArrowDropDown color="white" sx={{ fontSize: "22px" }} />
                    </div>
                  </div>
                </div>
                <div className="w-[10.3%] p-1 flex justify-between align-middle items-center">
                  <div className="w-[65%]">Client Name</div>
                  <div className="w-[35%] flex flex-col gap-y-1">
                    <div
                      className="cursor-pointer "
                      onClick={() => sortAlphabetically("client", "az")}
                    >
                      <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                    </div>

                    <div
                      className="cursor-pointer -mt-2"
                      onClick={() => sortAlphabetically("client", "za")}
                    >
                      <ArrowDropDown color="white" sx={{ fontSize: "22px" }} />
                    </div>
                  </div>
                </div>
                <div className="w-[12.3%] p-1 flex justify-between align-middle items-center ">
                  <div className="w-[65%]">Project Name</div>
                  <div className="w-[35%] flex flex-col gap-y-1">
                    <div
                      className="cursor-pointer"
                      onClick={() => sortAlphabetically("project", "az")}
                    >
                      <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                    </div>

                    <div
                      className="cursor-pointer -mt-2"
                      onClick={() => sortAlphabetically("project", "za")}
                    >
                      <ArrowDropDown color="white" sx={{ fontSize: "22px" }} />
                    </div>
                  </div>
                </div>
                <div className="w-[9.3%] p-1 flex justify-between align-middle items-center text-capitalize ">
                  <div className="w-[65%]">Lead Type</div>
                  <div className="w-[35%] flex flex-col gap-y-1">
                    <div
                      className="cursor-pointer "
                      onClick={() => sortAlphabetically("leadtype", "az")}
                    >
                      <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                    </div>

                    <div
                      className="cursor-pointer -mt-2"
                      onClick={() => sortAlphabetically("leadtype", "za")}
                    >
                      <ArrowDropDown color="white" sx={{ fontSize: "22px" }} />
                    </div>
                  </div>
                </div>
                <div className="w-[10.3%] pl-1 flex justify-between align-middle items-center text-capitalize ">
                  <div className="w-[75%] ">Quoted Value ({currency})</div>
                  <div className="w-[25%] flex flex-col text-start gap-y-1">
                    <div
                      className="cursor-pointer"
                      onClick={() => numericSort("za")}
                    >
                      <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                    </div>

                    <div
                      className="cursor-pointer -mt-2"
                      onClick={() => numericSort("az")}
                    >
                      <ArrowDropDown color="white" sx={{ fontSize: "22px" }} />
                    </div>
                  </div>
                </div>
                <div className="w-[10.3%] p-1 flex justify-start align-middle items-center text-capitalize ">
                  <div className="w-[70%] pl-2">Status</div>

                  <div className="w-[30%] flex flex-col text-center gap-y-1 ">
                    <div
                      className="cursor-pointer "
                      onClick={() => sortAlphabetically("leadstatus", "az")}
                    >
                      <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                    </div>

                    <div
                      className="cursor-pointer -mt-2"
                      onClick={() => sortAlphabetically("leadstatus", "za")}
                    >
                      <ArrowDropDown color="white" sx={{ fontSize: "22px" }} />
                    </div>
                  </div>
                </div>
                <div className="w-[11.3%] p-1 flex justify-between align-middle items-center text-capitalize ">
                  <div className="w-[65%]">Group</div>
                  <div className="w-[35%] flex flex-col gap-y-1">
                    <div
                      className="cursor-pointer"
                      onClick={() => sortAlphabetically("business", "az")}
                    >
                      <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                    </div>

                    <div
                      className="cursor-pointer -mt-2"
                      onClick={() => sortAlphabetically("business", "za")}
                    >
                      <ArrowDropDown color="white" sx={{ fontSize: "22px" }} />
                    </div>
                  </div>
                </div>
                <div className="w-[11.6%] p-1 flex justify-around align-middle items-center text-capitalize ">
                  <div className="w-[65%]">Follow-up Date</div>
                  <div className="w-[35%] flex flex-col gap-y-1 ">
                    <div
                      className="cursor-pointer"
                      onClick={() => sortAlphabetically("followupdate", "az")}
                    >
                      <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                    </div>

                    <div
                      className="cursor-pointer -mt-2"
                      onClick={() => sortAlphabetically("followupdate", "za")}
                    >
                      <ArrowDropDown color="white" sx={{ fontSize: "22px" }} />
                    </div>
                  </div>
                </div>
                <div className="w-[7%] p-1 flex justify-center items-center  break-words text-wrap whitespace-normal text-center text-capitalize ">
                  Attachments
                </div>
                {showActionColumn ? (
                  <div className="w-[6%] p-1 flex justify-center align-middle items-center rounded-tr-md">
                    Action
                  </div>
                ) : null}
              </div>
              <div>
                {currentItems.length > 0 ? (
                  currentItems.map((LeadReport, index) => {
                    const isFollowupDateToday = isSameDay(
                      LeadReport.FollowupDate,
                      new Date()
                    );
                    return (
                      <div
                        key={LeadReport.id}
                        className={`${
                          isFollowupDateToday ? "font-bold" : ""
                        } body flex w-full  text-xs text-capitalize 
                                          bg-white border-b border-gray-300
                                          `}
                      >
                        <div
                          className={`w-[5%] flex justify-start pl-2 align-middle items-center`}
                        >
                          {index + startIdx + 1}
                        </div>
                        <div className="w-[9.3%] p-1 flex justify-between align-middle items-center ">
                          {LeadReport.LeadDate
                            ? formatDateByCountry(LeadReport.LeadDate)
                            : ""}
                        </div>
                        <div className="w-[10.3%] p-1 flex justify-between align-middle items-center text-capitalize capitalize">
                          {LeadReport.ClientName}
                        </div>
                        <div className="w-[12.3%] p-1 flex justify-between align-middle items-center text-capitalize capitalize">
                          {LeadReport.ProjectName}
                        </div>
                        <div className="w-[9.3%] p-1 flex justify-between align-middle items-center text-capitalize capitalize">
                          {LeadReport.LeadType}
                        </div>
                        <div className="w-[10.3%] p-1 flex justify-center align-middle items-center break-all whitespace-normal">
                          {USAComma(LeadReport.QuotedValue)}
                        </div>
                        <div className="w-[10.3%] flex justify-start align-middle items-center text-capitalize capitalize">
                          <button
                            className={`border w-[90%] px-3 py-1 rounded-md ${getRowClass(
                              LeadReport.FollowupDate
                            )}`}
                          >
                            {LeadReport.Status === "Won Recurring" ||
                            LeadReport.Status === "won recurring"
                              ? "Won Rec"
                              : LeadReport.Status.charAt(0).toUpperCase() +
                                LeadReport.Status.slice(1).toLowerCase()}
                          </button>
                        </div>
                        <div className="w-[11.3%] p-1 flex justify-between align-middle items-center text-capitalize capitalize">
                          {getLeadGroupName(LeadReport)}
                        </div>
                        <div className="w-[11.6%] p-1 flex justify-between align-middle items-center text-capitalize">
                          {LeadReport.Status === "Won" ||
                          LeadReport.Status === "Lost"
                            ? ""
                            : formatDateByCountry(LeadReport.FollowupDate)}
                        </div>
                        <div className="w-[7%] relative p-1 flex gap-1 justify-center items-center text-center">
                          <AttachFileIcon
                            className="rotate-12 cursor-pointer"
                            onClick={() => {
                              setShowModal(true);
                              setattchmentLead(LeadReport);
                            }}
                          />

                          {/* <span className="min-w-4 text-center">
                                                    {allFiles?.filter((file) => file?.leadId === LeadReport._id).length || ""}
                                                </span> */}
                        </div>

                        {showActionColumn ? (
                          <div className="w-[6%] relative flex justify-center align-middle items-center font-bold ">
                            {isViewOnly ? (
                              <span style={{ opacity: 0.4, cursor: "not-allowed", fontSize: "18px", letterSpacing: "2px" }} title="View Only">
                                •••
                              </span>
                            ) : (
                              <>
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (openDropdownId !== LeadReport._id) {
                                      setOpenDropdownId(LeadReport._id);
                                    } else {
                                      setOpenDropdownId(null);
                                    }
                                  }}
                                  className="p-1 cursor-pointer dropdown-toggle-icon"
                                >
                                  <EllipsisVertical />
                                </div>

                                {openDropdownId === LeadReport._id && (
                                  <div
                                    ref={dropdownRef}
                                    className="z-50 p-1 absolute flex flex-col top-full bg-white rounded-md shadow border"
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <div
                                      onClick={() => {
                                        setOpenDropdownId(null);
                                        navigate(`/dashboard/edit-lead/${LeadReport.id}`);
                                      }}
                                      className="p-1 flex gap-1 w-full justify-start align-middle items-center border-b cursor-pointer hover:bg-gray-50"
                                    >
                                      <span title="Edit">
                                        <SquarePen size={15} className="text-blue-500" />
                                      </span>
                                      Edit
                                    </div>
                                    <div
                                      onClick={() => {
                                        setOpenDropdownId(null);
                                        openDeleteModal(LeadReport.id);
                                      }}
                                      className="p-1 flex gap-1 w-full justify-start align-middle items-center cursor-pointer hover:bg-gray-50"
                                    >
                                      <span title="Delete">
                                        <Trash2 size={15} className="text-blue-500" />
                                      </span>
                                      Delete
                                    </div>
                                  </div>
                                )}
                              </>
                            )}
                          </div>
                        ) : null}
                      </div>
                    );
                  })
                ) : (
                  <div
                    colSpan="9"
                    className="p-4 text-red-500 text-center h-[20rem] font-semibold text-[18px]"
                  >
                    {searchQuery
                      ? `No Result Found For "${searchQuery}"`
                      : "No Result Found"}
                  </div>
                )}
              </div>
            </div>
            <div className="pagination flex justify-between items-center bg-white rounded-b-md py-2 pl-2">
              <div>
                {totalItems > 0 ? (
                  <>
                    Showing {startIdx + 1} to {Math.min(endIdx, totalItems)} of{" "}
                    {totalItems} Entries
                  </>
                ) : (
                  <>Showing 0 Entries</>
                )}
              </div>
              {totalPages > 1 && (
                <div>
                  <button
                    onClick={() => setCurrentPage(1)}
                    className="px-1 py-1 mx-1 border rounded"
                    disabled={currentPage === 1}
                    title="First Page"
                  >
                    <KeyboardDoubleArrowLeftIcon className="w-4 h-4" />
                  </button>
                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.max(prev - 1, 1))
                    }
                    className="px-1 py-1 mx-2 border rounded"
                    disabled={currentPage === 1}
                  >
                    <ChevronRightIcon className="w-4 h-4 rotate-180" />
                  </button>

                  {Array.from({ length: 3 }, (_, index) => {
                    const pageNumber = currentPage - 1 + index;
                    if (pageNumber >= 1 && pageNumber <= totalPages) {
                      return (
                        <button
                          key={pageNumber}
                          onClick={() => setCurrentPage(pageNumber)}
                          className={`px-3 py-1 mx-2 border rounded ${
                            currentPage === pageNumber
                              ? "bg-gray-300 border"
                              : ""
                          }`}
                        >
                          {pageNumber}
                        </button>
                      );
                    }
                    return null;
                  })}

                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                    }
                    className="px-1 py-1 mx-2 border rounded"
                    disabled={currentPage === totalPages}
                  >
                    <ChevronRightIcon className="w-4 h-4" />
                  </button>
                  <button
                    onClick={() => setCurrentPage(totalPages)}
                    className="px-1 py-1 mx-1 border rounded"
                    disabled={currentPage === totalPages}
                    title="Last Page"
                  >
                    <KeyboardDoubleArrowRightIcon className="w-4 h-4" />
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
        {showModal && (
          <FileUploadFollowupTable
            LeadReport={attchmentLead}
            setShowModal={setShowModal}
            isViewOnly={isViewOnly}
          />
        )}
      </div>
    </div>
  );
};

export default FollowupTable;
